import { render } from "./CreateFacilityLoginModal.vue?vue&type=template&id=10af6e0d&ts=true"
import script from "./CreateFacilityLoginModal.vue?vue&type=script&lang=ts"
export * from "./CreateFacilityLoginModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__